import { useState, useEffect } from 'react';
// @mui
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import Container from '@mui/material/Container';
import { fCurrency } from 'src/utils/format-number';
// routes
import { format } from 'date-fns';
import { pt } from 'date-fns/locale';
import { paths } from 'src/routes/paths';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import Avatar from '@mui/material/Avatar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import TableCell from '@mui/material/TableCell';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { enqueueSnackbar } from 'notistack';
import Label from 'src/components/label/label';
import ListItemText from '@mui/material/ListItemText';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axiosInstance, { API_ENDPOINTS } from 'src/utils/axios';
import { ASSETS_API } from 'src/config-global';
import DishQuickForm from '../dish-quick-edit-form';

// ----------------------------------------------------------------------

function getIdRenderized(params) {
  const formated = params.id.split("-")[0];
  return (<Label title={params.id} variant="soft" color='primary' >{formated}</Label>);
}

function getPhotoRenderized(params) {
  return (
    <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            alt={params.row.portugueseName}
            variant="rounded"
            src={params.row.photo !== "" ? `${ASSETS_API + params.row.photo}` : `${ASSETS_API}/static/dish/default_dish.png`}
            sx={{ width: 54, height: 54, mr: 2 }}
          />

          <ListItemText
            disableTypography
            primary={params.row.portugueseName}
            secondary={
              <Box component="div" sx={{ typography: 'body2', color: 'text.disabled' }}>
                {params.row.category}
              </Box>
            }
          />
        </TableCell>
  );
}

function getCostRenderized(params) {
  return (<TableCell>{fCurrency(params.row.cost)} €</TableCell>);
}

function getModifiedDateRenderized(params) {
  if(params.row.modifiedAt === null)
  {
    return ( <TableCell> <Label variant="soft" color='default'>Sem Alteração</Label> </TableCell>);
  }
  if(params.row.modifiedAt !== null)
  {
  return (
    <TableCell>
          <ListItemText
            primary={format(new Date(params.row.modifiedAt), 'dd MMM yyyy', {locale:pt})}
            secondary={format(new Date(params.row.modifiedAt), 'p', {locale:pt})}
            primaryTypographyProps={{ typography: 'body2', noWrap: true }}
            secondaryTypographyProps={{
              mt: 0.5,
              component: 'span',
              typography: 'caption',
            }}
          />
        </TableCell>
  )
}
  return (<div> </div>);
}
function getCreatedDateRenderized(params) {

  return (
    <TableCell>
          <ListItemText
            primary={format(new Date(params.row.creationDate), 'dd MMM yyyy', {locale:pt})}
            secondary={format(new Date(params.row.creationDate), 'p', {locale:pt})}
            primaryTypographyProps={{ typography: 'body2', noWrap: true }}
            secondaryTypographyProps={{
              mt: 0.5,
              component: 'span',
              typography: 'caption',
            }}
          />
        </TableCell>
  )
}
export default function DishListView() {

  const [tableData, setTableData] = useState([]);
  const [currentData, setCurrentData] = useState({});
  const [toDeleteItem, setToDeleteItem] = useState();
  const quickEdit = useBoolean();
  const quickTypeForm = useBoolean();
  const handleEdit = async (params) => {
    quickTypeForm.onTrue();
    const fetchDish = async () => {
      let res = null;
      try {
       res  = await axiosInstance.get(`${API_ENDPOINTS.dish.get}${params.id}`);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      return res.data;
    };
    const result = await fetchDish();
    setCurrentData(result);
    quickEdit.onTrue();
  };
  const handleDelete = (params) => {
    setToDeleteItem(params.id);
    confirm.onTrue();
  };
  const confirmDelete = async () => {
    try {
      await axiosInstance.delete(`${API_ENDPOINTS.dish.delete}${toDeleteItem}`);
      setToDeleteItem();
      enqueueSnackbar(`Prato eliminado com sucesso!`,'success');
     } catch (error) {
      enqueueSnackbar(`Não foi possível eliminar o prato!`,'error');
     }

     fetchData();
  };
  const handleOnClose = () => {
    setCurrentData({});
    quickEdit.onFalse()
    fetchData();
  };

  function quickActions(params) {
    return ( <div>
      <Tooltip title="Editar" placement="top" arrow>
        <IconButton color={quickEdit.value ? 'inherit' : 'default'} onClick={() => handleEdit(params)}>
          <Iconify icon="solar:pen-bold" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar" placement="top" arrow>
      <IconButton onClick={() => handleDelete(params)}>
        <Iconify icon="solar:trash-bin-trash-bold" />
      </IconButton>
    </Tooltip></div>
    );
  }

  const columns = [
    { field: 'id', headerName: 'Id' , maxWidth:100, renderCell:getIdRenderized, align: 'left',headerAlign: 'left', hide: true},
    { field: 'portugueseName', headerName:'Name'},
    { field: 'category', headerName:'categoria'},
    { field: 'photos', headerName: 'Prato', minWidth:200,  flex:1, align: 'left',headerAlign: 'left', renderCell:getPhotoRenderized},
    { field: 'cost', headerName: 'Preço',  flex:1, align: 'left' ,headerAlign: 'left', renderCell: getCostRenderized},
    { field: 'creationDate', headerName: 'Data de Criação',  flex:1, align: 'left',headerAlign: 'left', renderCell: getCreatedDateRenderized},
    { field: 'modifiedAt', headerName: 'Data de Alteração',  flex:1, align: 'left',headerAlign: 'left', renderCell: getModifiedDateRenderized},
    {  field:'', headerName:'Ações',  flex:1 , align: 'center',headerAlign: 'center', renderCell: quickActions
    },
  ]
  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(API_ENDPOINTS.dish.list);
     setTableData(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const settings = useSettingsContext();
  const confirm = useBoolean();
  return (
    <div>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Lista de Pratos"
          links={[
            { name: 'Dashboard', href: paths.dashboard.root },
            { name: 'Lista de Pratos', href: paths.dashboard.param.dish_list },
            { name: 'Lista' },
          ]}
          action={
           
            <Button
              onClick={() => {quickEdit.onTrue(); quickTypeForm.onFalse();}}
              variant="contained"
              startIcon={<Iconify icon="mingcute:add-line" />}
            >
              Novo de prato
            </Button>
          }
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />
        {quickEdit.value ? <DishQuickForm current={currentData}  open={quickEdit.value} onClose={() => { handleOnClose() }} isEdit={quickTypeForm.value}/> : '' }
        <Card>
          
        <div style={{ minHeight:'400px', width: "100%" }}>
            <DataGrid
            initialState={{
              columns: {
                columnVisibilityModel: {
                  // Hide columns status and traderName, the other columns will remain visible
                  portugueseName: false,
                  category: false,
                },
              },
            }}
            density='comfortable'
            getRowId={(row) => row.id}
            rowSelection={false}
            rows={tableData}
            columns={columns}
            slots={{
              toolbar: GridToolbar,
              noRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  Sem Resultados
                </Stack>
              ),
              noResultsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  Sem Resultados
                </Stack>
              ),
            }} 
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            disableSelectionOnClick
            pageSize={5} 
            />
            </div>
        </Card>
      </Container>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Eliminar"
        content={
          <>
           Tem a certeza que deseja eliminar este prato?
          </>
        }
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              confirmDelete();
              confirm.onFalse();
            }}
          >
            Eliminar
          </Button>
        }
      />
    </div>
  );
}
